
/* styles */
require("!!../../../node_modules/.store/extract-text-webpack-plugin@2.1.2/node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../node_modules/.store/vue-loader@11.3.4/node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-f8dceab2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/.store/vue-loader@11.3.4/node_modules/vue-loader/lib/selector?type=styles&index=0!./index.vue")

var Component = require("!../../../node_modules/.store/vue-loader@11.3.4/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/.store/vue-loader@11.3.4/node_modules/vue-loader/lib/selector?type=script&index=0!./index.vue"),
  /* template */
  require("!!../../../node_modules/.store/vue-loader@11.3.4/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-f8dceab2\"}!../../../node_modules/.store/vue-loader@11.3.4/node_modules/vue-loader/lib/selector?type=template&index=0!./index.vue"),
  /* scopeId */
  "data-v-f8dceab2",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/SvgIcon/index.vue
// module id = 1772
// module chunks = 1